import type {
  ProjectDescriptionEntropyQuestionPostPayload,
  ProjectDescriptionEntropyQuestionResult,
} from './project-description-entropy-question.backend-model';
import type { ProjectDescriptionEntropyQuestion } from './project-description-entropy-question.model';

export function transformProjectDescriptionEntropyQuestion(
  response: ProjectDescriptionEntropyQuestionResult,
  request: ProjectDescriptionEntropyQuestionPostPayload,
): ProjectDescriptionEntropyQuestion {
  return {
    id: request.id,
    title: request.title,
    description: request.description,
    question: response.question,
    choices: response.suggestions,
  };
}
